export const PAYMENT_TERM = {
  REQUIRE_NET_30: 'require_net_30',
  DO_NOT_REQUIRE_NET_30: 'do_not_require_net_30',
} as const

export const INITIAL_PER_PAGE = 25

/**
 * 1. step_trip_details => step 1 on adhoc_booking
 * 2. step_checkout => step 2 on adhoc_booking
 * 3. step_payment => step 3 on adhoc_booking
 * 4. step_processing_payment => step 4 on adhoc_booking (Processing Payment Step)
 * 5. step_completed => step 5 on adhoc_booking (Completed Step - Payment Success)
 */
export const BOOKING_STEPS = {
  STEP_TRIP_DETAILS: 'step_trip_details',
  STEP_CHECKOUT: 'step_checkout',
  STEP_PAYMENT: 'step_payment',
  STEP_PROCESSING_PAYMENT: 'step_processing_payment',
  STEP_COMPLETED: 'step_completed',
} as const

/**
 * 1. step_trip_type => step 1 on booked_transportation
 * 2. step_date => step 2 on booked_transportation
 * 3. step_time => step 3 on booked_transportation
 * 4. step_routes => step 4 on booked_transportation
 * 5. step_add_ons => step 5 on booked_transportation (Final Step)
 * 6. step_completed => step 6 on adhoc_booking (Completed Step)
 */
export const BOOKED_TRANSPORTATION_STEPS = {
  STEP_TRIP_TYPE: 'step_trip_type',
  STEP_DATE: 'step_date',
  STEP_TIME: 'step_time',
  STEP_ROUTES: 'step_routes',
  STEP_ADD_ONS: 'step_add_ons',
  STEP_COMPLETED: 'step_completed',
} as const

/**
 * 1. point_to_point
 * 2. hourly_rental
 */
export const BOOKING_TRIP_TYPE = {
  POINT_TO_POINT: 'point_to_point',
  HOURLY_RENTAL: 'hourly_rental',
} as const

export const BOOKING_TRIP_TYPE_VALUES = {
  point_to_point: 'Point to Point',
  hourly_rental: 'Hourly Rental',
} as const

/**
 * 1. one_way
 * 2. two_way
 */
export const BOOKING_TRIP_DIRECTION = {
  ONE_WAY: 'one_way',
  TWO_WAY: 'two_way',
} as const

export const BOOKING_TRIP_DIRECTION_VALUES = {
  [BOOKING_TRIP_DIRECTION.ONE_WAY]: 'One Way',
  [BOOKING_TRIP_DIRECTION.TWO_WAY]: 'Two Way',
} as const

/**
 * 1. "booking_amendment_fee"
 * 2. "subsequent_amendment"
 * 3. "booking_cancellation_more_72"
 * 4. "booking_cancellation_within72"
 * 5. "booking_cancellation_within_48"
 */
export const BOOKING_PLANS_CODE = {
  BOOKING_AMENDMENT_FEE: 'booking_amendment_fee',
  SUBSEQUENT_AMENDMENT: 'subsequent_amendment',
  BOOKING_CANCELLATION_MORE_72: 'booking_cancellation_more_72',
  BOOKING_CANCELLATION_WITHIN_72: 'booking_cancellation_within_72',
  BOOKING_CANCELLATION_WITHIN_48: 'booking_cancellation_within_48',
} as const

export const PAYMENT_METHOD_CODE = {
  HIT_PAY: 'hit_pay',
  BANK_TRANSFER: 'bank_transfer',
  NET_30: 'net_30',
} as const

export const PAYMENT_METHOD_CODE_VALUES = {
  [PAYMENT_METHOD_CODE.HIT_PAY]: 'HitPay',
  [PAYMENT_METHOD_CODE.BANK_TRANSFER]: 'Bank Transfer',
  [PAYMENT_METHOD_CODE.NET_30]: 'Net 30',
} as const

export const HITPAY_PAYMENT_STATUS = {
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  REFUNDED: 'refunded',
  COMPLETED: 'completed',
} as const

export const HITPAY_PAYMENT_RESPONSE_STATUS = {
  PENDING: 'pending',
  ...HITPAY_PAYMENT_STATUS,
} as const

export const BOOKING_STATUS = {
  DRAFT: 'draft',
  WAITING_PAYMENT: 'waiting_payment',
  CONFIRMED: 'confirmed',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
  AMENDED: 'amended',
} as const

export const POINT_TO_POINT_CATEGORY = {
  DEPART_TRIP: 'depart_trip',
  RETURN_TRIP: 'return_trip',
} as const

export const POINT_TO_POINT_CATEGORY_LABELS = {
  [POINT_TO_POINT_CATEGORY.DEPART_TRIP]: 'Pickup Time',
  [POINT_TO_POINT_CATEGORY.RETURN_TRIP]: 'Return Time',
} as const

export const POINT_TO_POINT_CATEGORY_ALIAS = {
  [POINT_TO_POINT_CATEGORY.DEPART_TRIP]: 'Pickup',
  [POINT_TO_POINT_CATEGORY.RETURN_TRIP]: 'Return',
} as const

export const BOOKING_STATUS_ATTRIBUTION = {
  ...BOOKING_STATUS,
  WAITING_PAYMENT_OVERDUE: 'waiting_payment_overdue',
  WAITING_PAYMENT_BANK_TRANSFER: 'waiting_payment_bank_transfer',
  CONFIRMED_WITH_CANCELLED: 'confirmed_with_cancelled',
  REFUNDED_WAITING_PAYMENT: 'refunded_waiting_payment',
  REFUNDED_CONFIRMED: 'refunded_confirmed',
  REFUNDED_REJECTED: 'refunded_rejected',
  COMPLETED_WAITING_PAYMENT: 'completed_waiting_payment',
  COMPLETED_WITH_CANCELLED: 'completed_with_cancelled',
  CONFIRMED_WITH_AMENDMENT: 'confirmed_with_amendment',
} as const

export const BOOKING_TRANSPORTATION_STATUS = {
  ...BOOKING_STATUS,
  PENDING_APPROVAL: 'pending_approval',
} as const

export const BOOKING_REFUND_STATUS = {
  ACCEPTED: 'accepted',
  PENDING: 'pending',
  PROCESSING: 'processing',
  REJECTED: 'rejected',
  REFUNDED: 'refunded',
} as const

export const BOOKING_TRANSPORTATION_AMENDMENT_STATUS = {
  ...BOOKING_REFUND_STATUS,
} as const

export const BUS_DETAILS_TABS = {
  TRIP_SUMMARY: 'trip-summary',
  ROUTES: 'routes',
  ADD_ONS: 'add-ons',
  SPECIAL_REQUESTS: 'special-requests',
  PRICE_SUMMARY: 'price-summary',
} as const

export const BUS_DETAILS_TABS_LABELS = {
  [BUS_DETAILS_TABS.TRIP_SUMMARY]: 'Trip Summary',
  [BUS_DETAILS_TABS.ROUTES]: 'Routes',
  [BUS_DETAILS_TABS.ADD_ONS]: 'Add-ons',
  [BUS_DETAILS_TABS.SPECIAL_REQUESTS]: 'Special Requests',
  [BUS_DETAILS_TABS.PRICE_SUMMARY]: 'Price Summary',
} as const

export const BUS_DETAILS_TABS_POINT_LABELS = {
  [BUS_DETAILS_TABS.TRIP_SUMMARY]: 'Trip Summary',
  [BUS_DETAILS_TABS.ROUTES]: 'Routes',
  [BUS_DETAILS_TABS.ADD_ONS]: 'Add-ons',
  [BUS_DETAILS_TABS.SPECIAL_REQUESTS]: 'Itinerary/Remarks',
  [BUS_DETAILS_TABS.PRICE_SUMMARY]: 'Price Summary',
} as const

export const BUS_TRIP_TYPES = {
  HOURLY: 'hourly',
  ...POINT_TO_POINT_CATEGORY,
} as const

export const BUS_TRIP_TYPES_LABELS = {
  [BUS_TRIP_TYPES.HOURLY]: 'Hourly',
  [BUS_TRIP_TYPES.DEPART_TRIP]: 'First Trip',
  [BUS_TRIP_TYPES.RETURN_TRIP]: 'Return Trip',
} as const

export const BUS_TRIP_TYPES_TIME_FIELDS = {
  [BUS_TRIP_TYPES.HOURLY]: 'depart_time',
  [BUS_TRIP_TYPES.DEPART_TRIP]: 'depart_time',
  [BUS_TRIP_TYPES.RETURN_TRIP]: 'return_time',
} as const

export const ADDON_PRODUCT_TYPE = {
  ATTACHMENT: 'attachment',
  QUANTITY: 'quantity',
  NONE_IN_TYPE: 'none_in_type',
  DROPDOWN: 'dropdown',
} as const

export const PRICE_TYPE = {
  FEE: 'fee',
  DISCOUNT: 'discount',
  TOTAL: 'total',
  CANCEL: 'cancel',
  REFUND: 'refund',
} as const

export const ACTIVE_INACTIVE_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const

export const NOTIFICATION_CATEGORY = {
  ALL: 'all',
  BOOKINGS: 'bookings',
  PAYMENTS: 'payments',
  NEWS: 'news',
} as const

const BOOKING_ADHOC_ACTIVITY = {
  BOOKING_CANCELLED: 'adhoc_booking_cancelled',
  TRIP_COMPLETED: 'adhoc_trip_completed',
  TRIP_REMINDER_1_HOUR_BEFORE: 'adhoc_trip_reminder_1_hour_before',
  TRIP_REMINDER_1_DAY_BEFORE: 'adhoc_trip_reminder_1_day_before',
  BOOKING_REFUNDED: 'adhoc_booking_refunded',
  BOOKING_AMENDED: 'adhoc_booking_amended',
  BOOKING_CONFIRMED: 'adhoc_booking_confirmed',
} as const

const PAYMENT_ADHOC_ACTIVITY = {
  REFUND_PROCESSED: 'adhoc_refund_processed',
  NET_30_PAYMENT_DUE: 'adhoc_net_30_payment_due',
  PAYMENT_REMINDER: 'adhoc_payment_reminder',
  PAYMENT_REJECTED: 'adhoc_payment_rejected',
  PAYMENT_RECEIVED: 'adhoc_payment_received',
} as const

const NEWS_ADHOC_ACTIVITY = {
  ADHOC_NET_30_APPROVED: 'adhoc_net_30_approved',
  ADHOC_PASSWORD_RESET_COMPLETED: 'adhoc_password_reset_completed',
  ADHOC_EMAIL_VERIFIED: 'adhoc_email_verified',
  ADHOC_WELCOME_REGISTRATION: 'adhoc_welcome_registration',
} as const

export const NOTIFICATION_ACTIVITY = {
  ...BOOKING_ADHOC_ACTIVITY,
  ...PAYMENT_ADHOC_ACTIVITY,
  ...NEWS_ADHOC_ACTIVITY,
}

export const DIFFERENCE_TYPE = {
  DECREASE: 'decrease',
  INCREASE: 'increase',
  NOT_CHANGE: 'no change',
} as const

export const BOOKING_STATUS_PAYMENT = {
  PAID: 'paid',
  UNPAID: 'unpaid',
} as const

export const AMOUNT_SYMBOL = {
  POSITIVE: '+',
  MINUS: '-',
} as const

export const KOHBUS_URLS = {
  HOME: 'https://busbooking.sg/',
  CONTACT: 'https://busbooking.sg/contact-us/',
  ABOUT: 'https://busbooking.sg/about-us/',
  SERVICE: 'https://busbooking.sg/services/',
  BLOG: 'https://busbooking.sg/blog/',
  TERMS_CONDITION: 'https://busbooking.sg/legal/terms-and-conditions/',
  PRIVACY_POLICY: 'https://busbooking.sg/legal/privacy-policy/',
  SERVICE_ADHOC_TRANSPORTATION:
    'https://busbooking.sg/services/bus-charter-ad-hoc/',
  SERVICE_STAFF_WORKER:
    'https://busbooking.sg/services/staff-and-workers-regular-charter/',
  SERVICE_SCHOOL_BUS: 'https://busbooking.sg/services/school-bus-transport/',
  SERVICE_SG_TO_MY:
    'https://busbooking.sg/services/singapore-to-malaysia-bus-service/',
} as const

export const BUS_DETAIL_TIME_START = '07:00' as const

export const IMPORTANT_REMINDERS_TIME = {
  [BOOKING_TRIP_TYPE.HOURLY_RENTAL]: [
    'For same-day orders, requests must be placed at least 6 working hours in advance.',
    'You must start and end on time.',
    'Overtime charges of an extra hour of disposal will be charged after 10 mins of overtime.',
  ],
  [BOOKING_TRIP_TYPE.POINT_TO_POINT]: [
    'For same-day orders, requests must be placed at least 6 working hours in advance.',
    'Select an accurate pickup time and grace period of 10 mins maximum at 1st pickup point only. No waiting allowed at additional pickup points (i.e. pick and go).',
    'Beyond grace period, waiting charges apply at $30 per 15 mins block.',
  ],
} as const

export const BOOKING_CANCEL_TYPE = {
  PAYABLE: 'payable',
  REFUNDABLE: 'refundable',
} as const

export const TIMEZONE = {
  DEFAULT: 'Asia/Singapore',
} as const

export const STOP_POINT_TYPE = {
  PICKUP_POINT: 'pickup_point',
  DROP_OFF_POINT: 'dropoff_point',
} as const
